<div class="print-container">
    <h1 class="page-label">Scan Chamber - Select Chamber</h1>
</div>

<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
            <label class="col-sm-2 input-label" for="portal-input">Chamber:</label>
            <select [(ngModel)]="selectedService" class="col-sm-6 form-control" id="portal-input" [disabled]="isUiDisabled">
                <option [ngValue]="null"> -- Choose -- </option>
                <option *ngFor="let service of availableServices" [ngValue]="service">
                    {{ service.name }}
                </option>
            </select>
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onSelectServiceClicked()" class="submit btn btn-primary col-sm-3" [disabled]="isUiDisabled || selectedService === null">SELECT CHAMBER</button>
    </div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>